import type { DependencyContainer } from 'tsyringe'
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { DITokens } from '@/di'
import { useRouter, navigateTo } from '#app'
import { useProfileWeb } from '@/composables/useProfileWeb'
import { useAvailabilityValidation } from '@/composables/useAvailabilityValidation'

export const useCart = (container: DependencyContainer) => {
  const isValidatingAvailability = ref(false)
  const showAvailabilityValidationResultModal = ref(false)

  const { validateAvailabilities } = useAvailabilityValidation(container)

  const cartStore = container.resolve(DITokens.CartStore)
  const { normalizedAvailabilityValidationResultsByInventoryId, normalizedAvailabilityValidationResults } = storeToRefs(cartStore)
  
  const router = useRouter()

  // 遷移アクション
  const checkout = async (to: 'signin' | 'signup' | 'order') => {
    const genre = router.currentRoute.value.meta.genre
    if (!genre) throw new Error('genre must be specified')

    // 在庫・価格変動チェック
    isValidatingAvailability.value = true
    const validationResult = await validateAvailabilities(genre)
    isValidatingAvailability.value = false
    if (!validationResult) {
      showAvailabilityValidationResultModal.value = true
      return
    }

    const orderPagePath = `/${genre}/order`

    if (to === 'order') {
      router.push(orderPagePath)
    } else if (to === 'signin' || to === 'signup') {
      const { getCustomRedirectLink } = useProfileWeb()
      const link = getCustomRedirectLink(to, orderPagePath)
      navigateTo(link, { external: true })
    }
  }

  return {
    checkout,
    isValidatingAvailability,
    showAvailabilityValidationResultModal,
    normalizedAvailabilityValidationResultsByInventoryId,
    normalizedAvailabilityValidationResults
  }
}
